export const getImageResized = (
  url: string,
  width?: number,
  height?: number
) => {
  const idUrl = url?.match(/\/ids\/(\d+)\//)
  let newUrlproductImages = ''

  if (idUrl) {
    const [, id] = idUrl
    const newId = `${id}-${width ?? 200}-${height ?? 200}`

    newUrlproductImages = url.replace(id, newId).replace('http://', 'https://')
  }

  return newUrlproductImages || url
}

export const setImageDimensions = (
  url: string,
  width: number,
  height: number
) => {
  // This regex captures the ID and optionally existing dimensions
  const regex = /\/ids\/(\d+)(?:-\d+-\d+)?\//
  const replacement = `/ids/$1-${width}-${height}/`

  return url.replace(regex, replacement)
}
